<template>
<div>
  <section class="lineazul">
      <div class="container">
        <div class="row">
          <div class="col-md-10">
             <div class="texto-banner">
                <div class="textos-nosotros">
                    <p>About us</p>
                    <h1>We are a Company specialized in Real Estate Backed Loans, providing a more flexible, faster alternative to traditional Banking.</h1>
                    <h2>We have support from a solid international holding, and the financial experience of over 15 years with our Credix subsidiary in Mexico</h2>
                </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="aboutimg">
               <img src="https://lendarc.us/assets/images/logolendarc.png" alt="">
            </div>
          </div>
        </div>
         
      </div>
      
  </section>
  <section style="background-color:#006699;color: white;" class="py-5">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="textAb1">
          <h1>In Lendarc we are always looking to make things happen.</h1>
        </div>
      </div>
      
    </div>
  </div>
  </section>

  <section class="valoresab">
    <div class="container">
       <div class="titulos-iniciales ">
        <div class="titulo">
            <h1>Our   <span>values</span> </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
        <div class="valoritem">
          <div class="iconVal">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
              <path d="M37.09,10.94c-1.19-1.84-1.54-3.78-0.87-5.82c1.4-4.25,6.71-5.83,10.1-2.91c2.72,2.34,5.3,4.85,7.31,7.86  c0.41,0.61,0.9,0.9,1.6,1.04c3.53,0.69,6.91,1.86,10.14,3.45c0.55,0.27,0.96,0.27,1.48-0.09c2.14-1.46,4.29-2.92,6.49-4.29  c4.27-2.66,9.69-0.36,10.75,4.55c0.34,1.58,0.12,3.12-0.61,4.69c2.17,0.66,3.85,1.9,4.81,3.96c0.98,2.08,0.88,4.15-0.08,6.29  c2.19,0.64,3.87,1.88,4.82,3.95c0.96,2.07,0.86,4.16,0.03,6c1.22,0.85,2.52,1.49,3.47,2.47c2.86,2.92,2.47,7.79-0.76,10.29  c-1.46,1.13-3.09,2.06-4.59,3.15c-0.32,0.23-0.58,0.73-0.63,1.13c-0.26,1.93-0.4,3.88-0.65,5.82c-0.15,1.19-0.89,1.76-1.85,1.59  c-0.93-0.16-1.34-0.87-1.19-2.05c0.16-1.23,0.33-2.47,0.51-3.89c-0.37,0.2-0.58,0.29-0.77,0.41c-5.13,3.39-10.27,6.77-15.38,10.18  c-2.27,1.52-4.7,2.29-7.44,1.86c-2.7-0.43-4.85,0.74-6.81,2.34c0.22,0.74,0.57,1.45,0.64,2.19c0.16,1.84-0.75,3.14-2.26,4.14  c-7.03,4.63-14.05,9.29-21.07,13.94c-0.36,0.24-0.73,0.49-1.09,0.73c0,0.1,0,0.19,0,0.29c1.94,0.45,3.86,1.04,5.83,1.33  c14.83,2.2,27.45-2.13,37.74-13.04c3.44-3.65,5.99-7.9,7.83-12.56c0.14-0.36,0.26-0.72,0.42-1.07c0.41-0.93,1.16-1.31,1.99-1.01  c0.86,0.31,1.23,1.15,0.88,2.12c-1.17,3.24-2.67,6.31-4.6,9.16c-7.43,10.98-17.7,17.6-30.8,19.64c-22.92,3.57-45.28-12.01-50-34.75  c-4.62-22.26,7.73-44.09,29.16-51.51C33.4,11.92,35.2,11.48,37.09,10.94z M55.14,70.36c0.47-0.31,0.91-0.57,1.32-0.87  c2.37-1.73,5.01-2.35,7.9-1.95c1.73,0.24,3.3-0.17,4.75-1.12c8.12-5.37,16.23-10.74,24.34-16.13c1.99-1.32,2.5-3.74,1.27-5.63  c-1.24-1.89-3.66-2.37-5.67-1.1c-0.95,0.6-1.87,1.24-2.81,1.85c-1,0.64-1.91,0.53-2.43-0.29c-0.49-0.79-0.24-1.62,0.73-2.27  c1.41-0.95,2.84-1.86,4.23-2.82c1.94-1.34,2.43-3.78,1.16-5.66c-1.23-1.82-3.65-2.28-5.61-1.04c-0.95,0.6-1.87,1.24-2.81,1.85  c-0.99,0.64-1.92,0.53-2.44-0.28c-0.5-0.8-0.26-1.61,0.71-2.27c1.35-0.91,2.73-1.8,4.08-2.71c2.1-1.42,2.65-3.81,1.34-5.75  c-1.28-1.9-3.68-2.32-5.76-0.98c-1,0.64-1.96,1.33-2.97,1.95c-0.79,0.48-1.64,0.27-2.11-0.43c-0.46-0.7-0.3-1.55,0.42-2.12  c0.15-0.12,0.32-0.21,0.48-0.32c1.39-0.92,2.8-1.81,4.15-2.78c2.27-1.63,2.33-4.84,0.16-6.51c-1.45-1.11-3.19-1.12-4.91,0.03  c-5.24,3.46-10.46,6.93-15.7,10.39c-1.33,0.88-2.26,0.57-2.83-0.93c-0.58-1.53-1.15-3.05-1.73-4.58c-2.05-5.4-5.79-9.53-10.03-13.28  c-1.09-0.97-2.55-1.02-3.77-0.32c-1.16,0.67-1.84,1.96-1.58,3.34c0.13,0.67,0.48,1.32,0.83,1.91c2.98,4.97,4.02,10.3,2.8,15.97  c-1.31,6.1-2.77,12.16-4.2,18.23c-0.19,0.8-0.1,1.42,0.37,2.12c5.26,7.88,10.49,15.79,15.72,23.69  C54.74,69.8,54.93,70.05,55.14,70.36z M42.39,84.12c-0.22-0.34-0.4-0.64-0.6-0.93c-5.28-7.88-10.55-15.75-15.83-23.63  c-0.18-0.27-0.4-0.52-0.51-0.81c-0.29-0.77-0.16-1.47,0.57-1.94c0.69-0.44,1.35-0.33,1.92,0.24c0.22,0.22,0.39,0.51,0.57,0.77  c5.3,7.9,10.6,15.8,15.9,23.7c0.19,0.28,0.4,0.55,0.61,0.85c2.89-1.91,5.69-3.76,8.49-5.62c1.29-0.85,1.35-1.17,0.49-2.47  C47.35,64.24,40.7,54.2,34.06,44.16c-0.74-1.12-1.16-1.21-2.27-0.48c-2.7,1.78-5.4,3.56-8.09,5.35c-0.23,0.15-0.45,0.33-0.71,0.53  c0.53,0.8,1.03,1.54,1.52,2.29c0.64,0.98,0.55,1.82-0.21,2.37c-0.77,0.55-1.69,0.3-2.36-0.67c-0.52-0.75-1.02-1.52-1.56-2.32  c-5.02,3.31-9.94,6.55-14.84,9.82c-0.21,0.14-0.35,0.61-0.29,0.87C8.06,75.97,15.91,86.13,28.79,92.4c0.5,0.24,0.86,0.18,1.3-0.12  c2.02-1.36,4.05-2.7,6.08-4.04C38.23,86.88,40.28,85.52,42.39,84.12z M4.83,57.83c2.45-1.62,4.79-3.17,7.14-4.73  c6.08-4.03,12.17-8.06,18.25-12.09c1.85-1.23,3.46-1.2,5.25,0.05c0.12,0.08,0.25,0.14,0.42,0.23c0.88-3.81,1.79-7.53,2.58-11.29  c0.6-2.87,1.21-5.76,1.52-8.67c0.27-2.53-0.34-5.01-1.34-7.36C17.09,17.47,2.75,38.27,4.83,57.83z M62.98,17.02  c0-0.1,0-0.19-0.01-0.29c-2.14-0.75-4.29-1.5-6.64-2.32c0.8,2.01,1.49,3.74,2.21,5.55C60.06,18.95,61.52,17.98,62.98,17.02z"/>
              </svg>
            </div>
          <div class="textoValor">
            <h3>FRUGALITY</h3>
            <p>We acquire and produce in a measured, efficient and recursive way to achieve our goals and those of our clients.</p>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="valoritem">
          <div class="iconVal">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
              <g>
                <path d="M79.52,68.39c-1.27,5.45-2.78,6.96-7.62,7.52c-0.02,2.02-0.66,3.87-2.13,5.34c-1.47,1.47-3.29,2.18-5.31,2.16   c-0.28,1.13-0.38,2.24-0.82,3.21c-2.21,4.89-8.05,5.88-11.99,2.08c-1.15-1.11-2.26-2.27-3.46-3.48c-0.91,0.94-1.73,1.85-2.61,2.69   c-3.86,3.64-9.6,2.6-11.79-2.17c-0.43-0.94-0.55-2.02-0.84-3.15c-1.92-0.11-3.78-0.71-5.26-2.19c-1.45-1.46-2.06-3.29-2.16-5.38   c-2.08-0.06-3.9-0.69-5.35-2.14c-1.45-1.45-2.14-3.25-2.16-5.17c-1.32-0.42-2.62-0.66-3.77-1.22c-1.95-0.95-3.08-2.63-3.6-4.74   c-0.14-0.55-0.43-1.14-0.82-1.52C0.23,50.93-2.2,36.48,4.14,24.77C8.88,16,16.3,10.74,26.23,9.31c8.59-1.23,16.29,1,23.01,6.49   c0.64,0.52,0.99,0.47,1.6-0.03c6.04-4.92,12.95-7.15,20.74-6.68c4.3,0.26,8.33,1.42,12.13,3.42c1.07,0.56,1.54,1.4,1.31,2.3   c-0.34,1.31-1.54,1.82-2.9,1.23c-1.47-0.63-2.9-1.42-4.42-1.87c-10.01-2.92-18.86-0.81-26.39,6.4c-4.38,4.2-8.62,8.56-12.89,12.87   c-2.59,2.61-1.75,6.59,1.58,7.58c1.72,0.51,3.24,0.07,4.51-1.19c1.71-1.7,3.44-3.38,5.11-5.12c0.79-0.83,1.66-1.17,2.82-1.16   c2.54,0.03,5.07-0.01,7.61-0.11c2.44-0.09,4.4-1.26,6.1-2.93c1.12-1.1,2.22-2.24,3.35-3.34c0.81-0.79,1.65-0.94,2.45-0.5   c1.18,0.65,1.44,2.07,0.41,3.1c-2.15,2.15-4.1,4.55-6.83,6.05c-0.1,0.06-0.19,0.15-0.63,0.49c0.41,0.24,0.8,0.38,1.07,0.65   c5.37,5.35,10.75,10.7,16.09,16.09c1.62,1.63,3.14,3.35,4.73,5.06c3.85-3.46,6.66-7.86,7.96-13.16c1.53-6.23,0.85-12.23-2.02-17.97   c-0.22-0.43-0.45-0.85-0.62-1.3c-0.37-1,0.04-2.03,0.93-2.45c0.91-0.43,1.98-0.17,2.49,0.81c0.81,1.56,1.65,3.14,2.18,4.81   c3.75,11.78,1.26,22.14-7.23,31.09c-1.24,1.3-2.57,2.51-3.86,3.77c-0.13,0.13-0.25,0.29-0.34,0.46c-1.36,2.64-3.54,3.97-6.48,4.15   C79.69,68.33,79.61,68.37,79.52,68.39z M47.19,19.19c-9.4-8.48-25.26-8.81-35.24,1.39c-10.5,10.73-9.12,26.87-0.48,35.61   c1.44-1.46,2.83-2.97,4.33-4.37c4.37-4.12,10.92-2.28,12.33,3.45c0.14,0.58,0.17,1.19,0.25,1.83c2.09,0.04,3.89,0.7,5.35,2.15   c1.48,1.47,2.09,3.33,2.18,5.34c4.85,0.64,6.57,2.35,7.62,7.57c0.23,0.03,0.48,0.06,0.73,0.09c4.84,0.66,7.49,4.5,6.41,9.27   c-0.06,0.26,0,0.67,0.17,0.85c1.32,1.36,2.61,2.76,4.04,4c1.9,1.64,4.81,0.59,5.39-1.85c0.34-1.41-0.21-2.5-1.17-3.47   c-3.3-3.29-6.59-6.59-9.89-9.88c-0.27-0.27-0.54-0.55-0.76-0.87c-0.5-0.71-0.48-1.44,0.01-2.15c0.5-0.72,1.22-0.97,2.02-0.74   c0.44,0.12,0.86,0.44,1.19,0.76c3.33,3.25,6.64,6.53,9.96,9.8c0.3,0.29,0.58,0.61,0.92,0.85c1.1,0.8,2.3,0.96,3.53,0.34   c1.23-0.61,1.85-1.63,1.88-3.01c0.03-1.2-0.59-2.05-1.39-2.85c-4.87-4.86-9.73-9.72-14.59-14.59c-0.27-0.27-0.55-0.55-0.76-0.86   c-0.75-1.12-0.21-2.54,1.09-2.91c0.99-0.28,1.65,0.27,2.28,0.9c4.88,4.89,9.77,9.77,14.66,14.65c0.34,0.34,0.69,0.68,1.09,0.94   c1.13,0.72,2.31,0.75,3.47,0.09c1.12-0.64,1.68-1.64,1.7-2.93c0.02-1.15-0.55-2-1.33-2.78c-4.89-4.88-9.77-9.77-14.66-14.65   c-0.27-0.27-0.54-0.55-0.76-0.87c-0.51-0.75-0.41-1.76,0.2-2.39c0.66-0.68,1.66-0.79,2.46-0.22c0.34,0.24,0.63,0.54,0.93,0.83   c4.91,4.91,9.81,9.82,14.73,14.72c1.56,1.55,3.58,1.61,4.99,0.22c1.39-1.37,1.35-3.48-0.16-4.99   c-6.88-6.89-13.76-13.78-20.66-20.65c-0.22-0.22-0.59-0.41-0.9-0.41c-2.41-0.01-4.82,0-7.23,0.08c-0.45,0.01-0.99,0.25-1.32,0.56   c-1.49,1.41-2.93,2.89-4.38,4.34c-2.08,2.07-4.54,3.01-7.51,2.62c-3.47-0.46-6.63-3.78-6.91-7.27c-0.23-2.83,0.73-5.15,2.71-7.12   C39.55,26.83,43.34,23.03,47.19,19.19z M36.8,82.68c0.23,1.48,0.84,2.52,2.06,3.14c1.26,0.64,2.54,0.56,3.6-0.37   c1.3-1.14,2.53-2.37,3.7-3.64c1.34-1.45,1.25-3.46-0.09-4.76c-1.32-1.28-3.36-1.27-4.77,0.07c-1.14,1.08-2.29,2.16-3.31,3.35   C37.46,81.09,37.19,81.94,36.8,82.68z M25.39,71.25c0.68-0.31,1.49-0.48,2.03-0.96c1.34-1.19,2.62-2.46,3.81-3.8   c1.14-1.28,0.99-3.26-0.18-4.47c-1.19-1.23-3.13-1.46-4.45-0.32c-1.42,1.24-2.75,2.6-4,4.01c-0.9,1.02-0.94,2.3-0.32,3.52   C22.9,70.45,23.93,71.06,25.39,71.25z M33.22,78.66c0.38-0.17,1.21-0.36,1.77-0.85c1.32-1.16,2.57-2.42,3.75-3.72   c1.17-1.3,1.03-3.31-0.19-4.54c-1.21-1.21-3.16-1.4-4.45-0.26c-1.39,1.23-2.7,2.56-3.94,3.94c-0.91,1.02-0.95,2.3-0.36,3.52   C30.4,77.98,31.45,78.58,33.22,78.66z M17.75,63.69c0.67-0.27,1.47-0.39,1.97-0.84c1.41-1.25,2.77-2.58,4.01-4   c1.11-1.28,0.88-3.29-0.33-4.45c-1.23-1.18-3.19-1.32-4.46-0.17c-1.33,1.2-2.61,2.48-3.8,3.81c-0.94,1.04-1.06,2.31-0.44,3.59   C15.3,62.84,16.31,63.48,17.75,63.69z"/>
                <path d="M87.59,18.96c0.01-1.04,0.88-1.91,1.9-1.91c0.99,0,1.91,0.91,1.93,1.91c0.02,1.04-0.92,1.95-1.98,1.93   C88.38,20.87,87.58,20.02,87.59,18.96z"/>
                <path d="M47.12,64.37c0.02,1.01-0.85,1.92-1.87,1.96c-1.04,0.04-1.98-0.89-1.97-1.95c0.01-1.04,0.86-1.88,1.91-1.88   C46.23,62.5,47.1,63.34,47.12,64.37z"/>
              </g>
            </svg>
          </div>
          <div class="textoValor">
            <h3>TRUST</h3>
            <p>We strive daily to meet high quality standards to be confident with our team and customers.</p>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="valoritem">
          <div class="iconVal">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
              <path d="M29.85,18.35c0-0.97-0.01-1.82,0-2.68c0.06-5.06,3.74-8.79,8.79-8.82c7.58-0.04,15.15-0.04,22.73,0  c5,0.03,8.69,3.74,8.77,8.73c0.01,0.89,0,1.78,0,2.77c0.46,0,0.83,0,1.2,0c8.12,0,16.24,0,24.36,0c2.37,0,3.41,1.02,3.41,3.37  c0,20.81,0.01,41.62,0,62.43c0,5.33-3.71,9.02-9.07,9.02c-26.7,0.01-53.39,0.01-80.09,0c-5.4,0-9.08-3.7-9.08-9.11  c-0.01-20.78,0-41.56,0-62.33c0-2.31,1.08-3.38,3.42-3.38c8.09,0,16.18,0,24.27,0C28.94,18.35,29.33,18.35,29.85,18.35z M6.81,39.54  c-0.06,0-0.11,0.01-0.17,0.01c0,0.32,0,0.64,0,0.96c0,14.39,0,28.77,0,43.16c0,2.76,0.99,3.74,3.76,3.74c26.41,0,52.83,0,79.24,0  c2.71,0,3.72-1,3.72-3.68c0-14.42,0-28.84,0-43.26c0-0.31,0-0.62,0-0.93c-0.24,0.22-0.33,0.48-0.41,0.73  c-1.34,3.99-2.67,7.99-4.01,11.98c-1.4,4.18-4.45,6.37-8.86,6.38c-4.86,0-9.72,0-14.58,0c-0.34,0-0.68,0-1.11,0  c0,0.96,0.01,1.82,0,2.67c-0.02,1.89-1.18,3.08-3.04,3.08c-7.58,0.01-15.16,0.01-22.74,0c-1.81,0-2.98-1.2-3-3.02  c-0.01-0.88,0-1.77,0-2.73c-0.45,0-0.8,0-1.14,0c-4.8,0-9.59,0-14.39,0c-4.62,0-7.59-2.14-9.05-6.5  C9.62,47.94,8.21,43.74,6.81,39.54z M92.21,24.17c-28.19,0-56.27,0-84.34,0c-0.01,0.09-0.03,0.13-0.02,0.16  c2.93,8.81,5.85,17.62,8.8,26.42c0.49,1.46,1.48,2.12,3.07,2.13c5.12,0.02,10.23,0.01,15.35,0c0.15,0,0.3-0.02,0.54-0.04  c0-0.94-0.01-1.83,0-2.71c0.03-1.81,1.2-2.99,3.02-3c7.58-0.01,15.15-0.01,22.73,0c1.82,0,2.99,1.19,3.02,3c0.02,0.89,0,1.77,0,2.75  c0.43,0,0.78,0,1.12,0c4.73,0,9.46,0,14.19,0c2.34,0,3.13-0.56,3.86-2.77c1.32-3.96,2.64-7.93,3.96-11.89  C89.08,33.57,90.63,28.91,92.21,24.17z M64.39,18.33c0-0.85,0.01-1.69,0-2.54c-0.03-2-1.17-3.16-3.15-3.19c-0.83-0.01-1.66,0-2.49,0  c-6.62,0-13.23,0-19.85,0c-1.71,0-2.9,0.75-3.13,2.22c-0.18,1.14-0.04,2.32-0.04,3.51C45.24,18.33,54.74,18.33,64.39,18.33z   M58.59,52.96c-5.78,0-11.47,0-17.14,0c0,1.93,0,3.79,0,5.63c5.75,0,11.43,0,17.14,0C58.59,56.7,58.59,54.86,58.59,52.96z"/>
            </svg>
          </div>
          <div class="textoValor">
            <h3>PROFESSIONALISM</h3>
            <p>Essential foundation for us and each of the members of our team.</p>
          </div>
        </div>
      </div>
      </div>
    </div>
  </section>
 
</div>

</template>

<script>
export default {

}
</script>

<style lang="css">
.logonosotros img {
  width: 200px;
}
.lineazul {
  position: relative;
}
.aboutimg{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.aboutimg img {
 width: 200px;
}
.texto-banner {
  display: flex;
  flex-direction: row;
}
.textos-nosotros {
  padding-top: 60px;
  padding-bottom: 60px;
  width: 100%;
}
.textos-nosotros p {
  color: #006699;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 26px;
}
.textos-nosotros h1 {
  font-size: 29px;
  line-height: 48px;
  letter-spacing: 0.5px;
  padding-bottom: 20px;
  color: #1f2d27;
  width: 100%;
}
.textos-nosotros h2 {
  color: #596b64;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.5px;
  line-height: 28px;
  width: 80%;
}
.textAb1 {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: justify;
  flex-direction: column;
 
}
.part2ab{
  padding-left: 6rem;
    height: 100%;
}
.textAb1 h1{
  font-size: 25px;
  padding: 0 3rem;
}
.textAb1 h4{
  font-weight: 300;
  font-size: 18px;
}

.itemabout{
  width: 100%;
  display: flex;
  color: white;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 1rem;
}
.itemabout svg{
  fill: white;
  width: 25px;
}
.itemabout p{
  font-size: 18px;
  margin: 0 0 0 10px;
}
.valoresab{
  margin: 2.3rem 0;
}
.valoritem{
  display: flex;
  margin: 2rem 0;
}
.valoritem .iconVal{
  margin-right: 2rem;
}
.valoritem svg{
  width: 40px;
  fill: #006699;
}
.valoritem .textoValor h3{
  font-size: 18px;
  color: #006699;
}
.valoritem .textoValor p{
  font-size: 14px;
  font-weight: 400;
  text-align: justify;
}
@media only screen and (max-width: 768px) {
  .texto-banner {
    padding: 0 2rem;
  }
  .textos-nosotros {
    padding-top: 45px;
  }
  .textos-nosotros h1 {
    font-size: 25px;
    line-height: 37px;
    width: 100%;
    padding-bottom: 20px;
    text-align: justify;
  }
  .textos-nosotros h2 {
    width: 100%;
  }
  .texto-acerca {
    padding: 0 2rem;
  }
  .aboutimg img{
    margin-bottom:2rem;
  }
  .part2ab{
    margin-top: 1.5rem;
     padding-left: 3rem;
  }
}

</style>